import { createFileRoute } from '@tanstack/react-router';
import { AgreementListPage } from '@/pages/member-portal/agreements/AgreementListPage';
import { agreementGroupSearchSchema } from '@/pages/member-portal/agreements/agreementGroups';

function MemberPortalAgreementsRoute() {
	return <AgreementListPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/agreements')({
	component: MemberPortalAgreementsRoute,
	validateSearch: agreementGroupSearchSchema,
});
